import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as contractActions from '../../../redux/contract/actions';
import ENUMS from '../../../enums';
import DatePicker from './../../../components/FormElements/DatePicker/DatePicker';
import { Tooltip } from 'reactstrap';
import Select from 'react-select';

const ReportListFilter = props => {
  const formRefrence = useRef();
  const { applyFilters, cities, getCitiesContract } = props;
  const [btnClicked, setBtnClicked] = useState('');
  const [name, setName] = useState('');
  const [managerName, setManagerName] = useState('');
  const [contractNumber, setContractNumber] = useState('');
  const [tooltipNameOpen, setTooltipNameOpen] = useState(false);
  const [tooltipManagerNameOpen, setTooltipManagerNameOpen] = useState(false);
  const [tooltipContractNumberOpen, setTooltipContractNumberOpen] = useState(
    false,
  );
  const [cityCode, setCityCode] = useState([]);
  const [cafeType, setCafeType] = useState('');

  useEffect(() => {
    getCitiesContract();
  }, []);

  const toggleName = () => setTooltipNameOpen(!tooltipNameOpen);
  const toggleManagerName = () =>
    setTooltipManagerNameOpen(!tooltipManagerNameOpen);
  const toggleContractNumber = () =>
    setTooltipContractNumberOpen(!tooltipContractNumberOpen);

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setName('');
    setManagerName('');
    setContractNumber('');
    setCityCode('');
    setCafeType('');
    applyFilters(event);
  };

  return (
    <article>
      <form
        onReset={event => resetForm(event)}
        onSubmit={event => applyFilters(event, cityCode.value)}
        id='form'
        ref={formRefrence}
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>

        <main className='card-body'>
          <div className='d-flex row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1'>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <label className='rsee-form-label col-lg-5 text-right'>
                {locales('fields.cafe.name')}
              </label>
              <div className='full-width'>
                <input
                  name='cafeNamePart'
                  type='text'
                  value={name}
                  onChange={event => setName(event.target.value)}
                  className='form-control col-12'
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='cafeNamePart'
                />
                <Tooltip
                  placement='top-start'
                  isOpen={tooltipNameOpen}
                  target='cafeNamePart'
                  toggle={toggleName}
                >
                  {locales('maxLength.50')}
                </Tooltip>
              </div>
            </div>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <label className='rsee-form-label col-lg-5 text-right'>
                {locales('fields.cafe.owner.full.name')}
              </label>
              <div className='full-width'>
                <input
                  name='cafeManagerNamePart'
                  type='text'
                  value={managerName}
                  onChange={event => setManagerName(event.target.value)}
                  className='form-control col-12'
                  placeholder={locales('fields.cafe.owner.full.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='cafeManagerNamePart'
                />
                <Tooltip
                  placement='top-start'
                  isOpen={tooltipManagerNameOpen}
                  target='cafeManagerNamePart'
                  toggle={toggleManagerName}
                >
                  {locales('maxLength.50')}
                </Tooltip>
              </div>
            </div>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <label className='rsee-form-label col-lg-5 text-right'>
                {locales('fields.contractNumber')}
              </label>
              <div className='full-width'>
                <input
                  name='contractNumberPart'
                  type='text'
                  value={contractNumber}
                  onChange={event => setContractNumber(event.target.value)}
                  className='form-control col-12'
                  placeholder={locales('fields.contractNumber')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                  id='contractNumberPart'
                />
                <Tooltip
                  placement='top-start'
                  isOpen={tooltipContractNumberOpen}
                  target='contractNumberPart'
                  toggle={toggleContractNumber}
                >
                  {locales('maxLength.50')}
                </Tooltip>
              </div>
            </div>
          </div>
          <div className='d-flex row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1'>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <label
                className='rsee-form-label col-lg-5 text-right'
                htmlFor='cities'
              >
                {locales('messages.selectCities')}
              </label>
              <div className='full-width'>
                <Select
                  placeholder={locales('messages.select.cities')}
                  isMulti={false}
                  value={cityCode}
                  id='cityCode'
                  name='cityCode'
                  options={cities?.map(x => ({
                    value: x.cityCode,
                    label: x.name,
                  }))}
                  onChange={selected => setCityCode(selected)}
                />
              </div>
            </div>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <label
                className='rsee-form-label col-lg-5 text-right'
                htmlFor='cafeType'
              >
                {locales('cafes.type')}
              </label>
              <div className='full-width'>
                <Select
                  placeholder={locales('messages.select.cafes.type')}
                  isMulti={false}
                  value={cafeType}
                  id='cafeType'
                  name='cafeType'
                  options={ENUMS.CAFE_TYPE.list?.map(type => ({
                    value: type.value,
                    label: type.title,
                  }))}
                  onChange={selected => setCafeType(selected)}
                />
              </div>
            </div>
            <div className='d-flex col-lg-4 col-md-12 col-sm-12 my-1'>
              <input
                type='checkbox'
                name='isExpireIn14Days'
                id='isExpireIn14Days'
                value='true'
                maxLength='10'
              />
              <label
                className='mx-1 text-center my-2 p-0'
                htmlFor='isExpireIn14Days'
              >
                {locales('fields.cafe.contract.end.date.14.days.ago')}
              </label>
            </div>
          </div>
          <div className='col-12 d-flex justify-content-end p-0 my-3'>
            <input
              name='resetButton'
              type='reset'
              value={locales('fields.reset')}
              className='btn btn-danger w-5 mx-2'
              maxLength='10'
            />
            <button
              type='submit'
              id='apply-filter-btn-cafe'
              className='btn btn-success w-5 mx-2'
              name='filter'
              onClick={() => setBtnClicked('filter')}
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  const { cities, getCitiesContractLoading } = state.cafesContractReducer;

  return {
    cities,
    getCitiesContractLoading,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCitiesContract: () => dispatch(contractActions.getCitiesContract()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportListFilter);
